import { useEffect, useState } from 'react';

import { BREAK_POINTS } from 'src/front/constant';

interface DeviceTypeResult {
  isPhone: boolean;
  isTablet: boolean;
  isDesktop: boolean;
}
const defaultValues = {
  isPhone: false,
  isTablet: false,
  isDesktop: false,
};

const phoneMatchMedia = window.matchMedia(`(max-width: ${BREAK_POINTS.MAX.PHONE_PORTRAIT})`);
const tabletMatchMedia = window.matchMedia(
  `(min-width: ${BREAK_POINTS.MIN.PHONE_PORTRAIT}) and (max-width: ${BREAK_POINTS.MAX.TABLET})`
);
const desktopMatchMedia = window.matchMedia(`(min-width: ${BREAK_POINTS.MIN.TABLET})`);

const useDeviceType = (): DeviceTypeResult => {
  const [deviceType, setDeviceType] = useState<DeviceTypeResult>(() => ({
    isPhone: phoneMatchMedia.matches,
    isTablet: tabletMatchMedia.matches,
    isDesktop: desktopMatchMedia.matches,
  }));

  useEffect(() => {
    const phoneListener = (event: MediaQueryListEvent): void => {
      if (event.matches) {
        setDeviceType({
          ...defaultValues,
          isPhone: true,
        });
      }
    };

    const tabletListener = (event: MediaQueryListEvent): void => {
      if (event.matches) {
        setDeviceType({
          ...defaultValues,
          isTablet: true,
        });
      }
    };

    const desktopListener = (event: MediaQueryListEvent): void => {
      if (event.matches) {
        setDeviceType({
          ...defaultValues,
          isDesktop: true,
        });
      }
    };

    phoneMatchMedia.addEventListener('change', phoneListener);
    tabletMatchMedia.addEventListener('change', tabletListener);
    desktopMatchMedia.addEventListener('change', desktopListener);

    return () => {
      phoneMatchMedia.removeEventListener('change', phoneListener);
      tabletMatchMedia.removeEventListener('change', tabletListener);
      desktopMatchMedia.removeEventListener('change', desktopListener);
    };
  }, []);

  return deviceType;
};

export default useDeviceType;
